import axios from "@/axios/development";

export default async function (case_id) {
    if (typeof case_id !== "string") throw new TypeError("case_id must be a string, instead of:", case_id);
    return (await axios(`/active-passive-media/${case_id}`)).data.data;
}
